import { Grid } from "@mui/material";
import { DismissSupplierPendingInventoryActivityDialog } from "./dialogs/DismissSupplierPendingInventoryActivityDialog";
import { PendingInventoryActivityVO } from "../../../types/model/valueObject/pendinginventoryactivity/PendingInventoryActivityVO";
import { ReportDialogWrapperProps } from "../../../interfaces";

export const dialogs = Object.freeze({
  DISMISS: "DISMISS",
});

const SupplierPendingInventoryActivityDialogWrapper = ({
  dialog,
  onClose
}: ReportDialogWrapperProps<PendingInventoryActivityVO>) => {

  const isOpen = (dialogType: string) => {
    return dialog?.dialog === dialogType && Boolean(dialog?.item)
  }

  return <Grid>
    <DismissSupplierPendingInventoryActivityDialog open={isOpen(dialogs.DISMISS)} item={dialog.item} onClose={onClose} />
  </Grid>
}

export { SupplierPendingInventoryActivityDialogWrapper };
